<template>
	<section>
		<!-- Componentes externos -->
    <crear-actualizar-item />
    <h3 class="primary--text"><v-icon color="primary">business</v-icon> Items</h3>
		<v-card>
			<v-card-text>
				<crud-table
					:headers="headers"
          :url="url"
          :filters="filters"
          :data-graphql="dataGraphql"
					:graphql="graphql"
				>
					<!-- Template injectable de la cabecera de la tabla -->
					<template slot="buttons">
            <v-tooltip bottom>
             <v-btn color="primary" dark
               @click.native.stop="crearActualizarItem({})"
               slot="activator"
             ><v-icon dark>add</v-icon> {{$t('common.add') }}</v-btn>
             <span>Agregar Item</span>
           </v-tooltip>
          </template>

					<!-- Template de filas y columnas -->
					<template slot="items" slot-scope="items">
						<!-- Agregar las columnas que consideré necesarias -->

            
            <td class="text-xs-center">{{ items.item.nro_item }}</td>
            <td class="text-xs-center">{{ items.item.id_estado }}</td>
            <td class="text-xs-center">{{ items.item.movilidades.length > 0 ? items.item.movilidades[0].persona.nombres:'' }}</td>
            <td class="text-xs-center">{{ items.item.movilidades.length > 0 ? items.item.movilidades[0].cargo.denominacion:'' }}</td>
            <td class="text-xs-center">{{ items.item.movilidades.length > 0 ? items.item.movilidades[0].puesto.denominacion:'' }}</td>
            <td class="text-xs-center">{{ items.item.movilidades.length > 0 ? items.item.movilidades[0].tipo_justificacion.descripcion:'' }}</td>
            <td class="text-xs-center">{{ items.item.denominacion }}</td>
            
            <!-- <td class="text-xs-center">{{ items.item.nombre }}</td> -->

            <td class="nowrap text-xs-center">
              <v-tooltip bottom>
                <v-btn
                  icon
                  slot="activator"
                  @click.native="crearActualizarItem(items.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <span>Editar registro</span>
              </v-tooltip>
            </td>
          </template>

				</crud-table>
			</v-card-text>
		</v-card>
	</section>
</template>

<script>
import CrudTable from '@/common/util/crud-table/CrudTable.vue'; // Componente Tabla Dinámica
import crud from '@/common/util/crud-table/mixins/crud-table'; // Funciones y Metodos
import CrearActualizarItem from './dialogs/CrearActualizarItem' // Componente de creación y actualización

export default {
	// Importación de métodos y funciones de un archivo mixin 
	mixins: [crud],
	// Variables iniciales del componente
	data () {
		return {
			url: 'items',
			graphql: true,
			// Cabecera de la tabla
			headers: [
        // { text: 'Nombre de la cabecera', value: 'Campo que deseamos interpolar', align: 'center' },

				{ text: 'Nro item', value: 'nro_item'},
        { text: 'Estado', value: 'id_estado' },
        { text: 'Nombres', value: 'nombres' },
        { text: 'Cargo', value: 'denominacion' },
        { text: 'Nombre Puesto', value: 'denominacion' },
        { text: 'Descripcion', value: 'descripcion' },

        { text: this.$t('common.actions'), sortable: false, align: 'center' }
      ],
			// Campos solicitados de Graphql(Agregar los que necesite)
			dataGraphql: `
           
                  nro_item
                  id_estado
                  movilidades{
                    id_estado
                    persona{
                      nombres
                    }
                    cargo{
                      denominacion
                    }
                    puesto{
                      denominacion
                    }
                    tipo_justificacion{
                      descripcion
                    }
                  }
               

      `,
			// Filtros del componente CrudTable ejemplo:
			// {
			// 	field: 'Campo definido en Graphql',
			// 	label: 'Etiqueta del input generado',
			// 	type: 'text', // Tipo de input en el filtro
			// 	typeG: 'String' // Tipo definido en Graphql
			// }
			filters: []
		}
	},
	// Funcionalidades que se ejecutan al montar el componente
  mounted () {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0] // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push('/403')
    }

    this.$bus.$on('closeDialog', () => {
      this.updateList()
    })
  },
	// Métodos y funciones del componente
	methods: {
		crearActualizarItem (item) {
			this.$bus.$emit('openDialogCrearActualizarItem', item)
		},
		async cambiarEstado (item) {
      let value = item.id_estado === '20' ? 1 : 20
      let data = {
        id_estado: value
      }
      try {
        await this.$service.graphql({
          query: `
            mutation edit($id: ID!, $item: EditItem!) {
              itemEdit(id: $id, item: $item) {
                id
              }
            }
          `,
          variables: {
            id: item.id,
            item: data
          }
        })
        if (value === 1) {
          this.$message.success('Item habilitado')
        } else {
          this.$message.warning('Item deshabilitado')
        }
        this.updateList()
      } catch (error) {
        console.log(error)
      }
    }
	},
	// Definición de componentes importados
	components: {
		CrudTable,
		CrearActualizarItem
	}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/admin/item/Index.vue